var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 30.016V24q0-.64.352-1.12t.864-.704 1.12-.128 1.088.544l1.568 1.6 5.6-5.6q.384-.384.832-.512t.864-.064.768.32.608.608.32.8-.032.832-.544.832l-5.568 5.6 1.568 1.568q.48.48.576 1.088t-.128 1.12-.736.864T8 32H2.016q-.832 0-1.44-.576T0 30.016m18.048-17.728q-.096-.416.032-.864t.512-.832l5.568-5.568-1.568-1.6q-.48-.448-.544-1.056t.096-1.152.736-.864T24 0h6.016q.8 0 1.408.608T32 2.016V8q0 .64-.352 1.152t-.864.704-1.12.128-1.056-.576l-1.6-1.568-5.6 5.568q-.352.384-.8.512t-.864.064-.8-.32-.576-.608-.32-.768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximise);
export default __webpack_public_path__ + "static/media/maximise.03a665ae045668afdccc59af884c1001.svg";
export { ForwardRef as ReactComponent };